import { MainPage } from ':fat/messaging/entities/mainPage';

export async function sanityCheck() {
  // TODO: Check that all browser dependencies we'll need are present and that
  // everything was loaded successfully

  try {
    await MainPage.actions.ping();
  } catch (error: unknown) {
    let errorMessage = 'Could not ping a neighbor';
    if (error instanceof Error) {
      errorMessage += `: ${error.message}`;
    }
    return { success: false, errorMessage };
  }

  return { success: true, errorMessage: undefined };
}
